import { createFileRoute } from '@tanstack/react-router';
import { CampaignsListPage } from '@/pages/member-portal/campaigns/CampaignsListPage';

// Campaigns viewer — member-facing list grouped active → upcoming → past.
function MemberPortalCampaignsRoute() {
	return <CampaignsListPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/campaigns')({
	component: MemberPortalCampaignsRoute,
});
